/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InactiveCleanupCandidateDTOFromJSON, InactiveCleanupCandidateDTOToJSON, } from './InactiveCleanupCandidateDTO';
/**
 * Check if a given object implements the PaginatedResponseInactiveCleanupCandidateDTO interface.
 */
export function instanceOfPaginatedResponseInactiveCleanupCandidateDTO(value) {
    return true;
}
export function PaginatedResponseInactiveCleanupCandidateDTOFromJSON(json) {
    return PaginatedResponseInactiveCleanupCandidateDTOFromJSONTyped(json, false);
}
export function PaginatedResponseInactiveCleanupCandidateDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : (json['items'].map(InactiveCleanupCandidateDTOFromJSON)),
    };
}
export function PaginatedResponseInactiveCleanupCandidateDTOToJSON(json) {
    return PaginatedResponseInactiveCleanupCandidateDTOToJSONTyped(json, false);
}
export function PaginatedResponseInactiveCleanupCandidateDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'currentPage': value['currentPage'],
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : (value['items'].map(InactiveCleanupCandidateDTOToJSON)),
    };
}
